var termsConditionsModal = {
  elWrap: $("#terms-conditions-modal"),
  closeEl: $("#closeRegisterSocialModal"),
  toggle: $("#termsConditionsSocial"),
  submitEl: $("#submitRegisterSocialModal"),

  customClose: function() {
    termsConditionsModal.closeEl.click(function(e) {
      e.preventDefault();
      modal.hide();
    });
  },

  toggleButton: function() {
    termsConditionsModal.toggle.click(function() {
      if (termsConditionsModal.submitEl.prop("disabled")) {
        termsConditionsModal.submitEl.prop("disabled", false);
      } else {
        termsConditionsModal.submitEl.prop("disabled", true);
      }
    });
  },

  show: function() {
    var timer = termsConditionsModal.elWrap.attr("data-triggerdelay") * 1000;
    setTimeout(function() {
      modal.show("#terms-conditions-modal");
      termsConditionsModal.customClose();
      termsConditionsModal.toggleButton();
    }, timer);
  },

  init: function() {
    if (termsConditionsModal.elWrap.length > 0) {
      termsConditionsModal.show();
    }
  }
};
